export default __webpack_public_path__ + "static/media/failIcon.b966a02f.svg";